import React, { useState, useEffect } from 'react'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  TableFooter,
  Typography,
} from '@mui/material'
import { useNavigate, useSearchParams } from 'react-router-dom'
import Row from './Row'
import SkeletonRow from '../../../shared/SkeletonRow'
import { TablePaginationActions } from '../../../shared/TablePagination'
import { useGetEndUserAppleLuckyDraws } from '../../../../api/promotions/end-user/end-user-apple-lucky-draw'

const AppleLuckyDrawTable = () => {
  const navigate = useNavigate()

  const [searchParams] = useSearchParams()
  const pageParam = Number(searchParams.get('page'))
  const limitParam = Number(searchParams.get('limit'))
  const nameParam = searchParams.get('name') ?? ''

  const [page, setPage] = useState(Number.isInteger(pageParam) ? pageParam : 0)
  const [limit, setLimit] = useState(limitParam ? limitParam : 10)
  const [name, setname] = useState(nameParam)

  useEffect(() => {
    if (Number.isInteger(pageParam)) setPage(pageParam)
    if (limitParam) setLimit(limitParam)
    setname(nameParam)
  }, [limitParam, pageParam, nameParam])

  const { data, isLoading } = useGetEndUserAppleLuckyDraws({
    page: page + 1,
    limit,
    ...(name && { name }),
  })

  const tableData = data?.docs ?? []

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [limit, page])

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
    const params = new URLSearchParams({
      page: newPage,
      limit,
      ...(name && { name }),
    })
    navigate(`?${params.toString()}`)
  }

  const handleChangeRowsPerPage = (event) => {
    if (limit) {
      const newLimit = parseInt(event.target.value, 10)
      setLimit(newLimit)
      setPage(0)
      const params = new URLSearchParams({
        page: 0,
        limit: newLimit,
        ...(name && { name }),
      })
      navigate(`?${params.toString()}`)
    }
  }

  return (
    /* css overflow patch fix for scrollbar appearing despite not necessary */
    <TableContainer component={Paper} style={{ overflowY: 'hidden' }}>
      <Table sx={{ minWidth: 720 }} aria-label='simple table'>
        <TableHead>
          <TableRow>
            <TableCell width={100}>
              <Typography variant='body2' fontWeight={900} color={'gray'}>
                Status
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant='body2' fontWeight={900} color={'gray'}>
                Name
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant='body2' fontWeight={900} color={'gray'}>
                Brand
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant='body2' fontWeight={900} color={'gray'}>
                Serial Number
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant='body2' fontWeight={900} color={'gray'}>
                Phone
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant='body2' fontWeight={900} color={'gray'}>
                Reject Reason
              </Typography>
            </TableCell>
            <TableCell align='right'></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading
            ? Array(10)
                .fill()
                .map((_, idx) => <SkeletonRow key={idx} height={30} />)
            : [...(tableData ?? [])].map((row, idx) => <Row key={idx} row={row} />)}

          {!data?.totalDocs && !isLoading && (
            <TableRow>
              <TableCell colSpan='100%' height={30}>
                <Typography variant='h2' align='center' fontWeight={900}>
                  No Data
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            {data?.totalDocs && (
              <TablePagination
                rowsPerPageOptions={[10, 25, 50, 100]}
                colSpan={10}
                count={data?.totalDocs}
                rowsPerPage={limit}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            )}
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  )
}

export default AppleLuckyDrawTable
